import React from 'react'
import '../styles/ConfidenceBar.css'

function ConfidenceBar(props) {
  const withMinimum = (confidence) => {
    const minimum = 1
    return confidence >= minimum || confidence === 0 ?
    Math.floor(confidence) :
    minimum
  }

  return (
    <div
      className='confidenceBar'
      style={props.style || {}}
    >
      <div
        id='confidence-bar-conf'
        style={
          {
            width: `${withMinimum(props.confidence * 100)}%`,
            height: '10px',
            borderRadius: '5px',
            backgroundColor: props.color,
          }
        }
      />
    </div>
  )
}

export default ConfidenceBar
